import { useTranslations } from 'next-intl'

import S from './FanGrowthCard.module.scss'

const FanGrowthCard = () => {
  const t = useTranslations('club.stats')

  const bars: Array<{
    day: number
    height: number
    highlight?: boolean
    value?: number
  }> = [
    { day: 5, height: 40 },
    { day: 6, height: 56 },
    { day: 7, height: 64 },
    { day: 8, height: 92 },
    { day: 9, height: 104 },
    { day: 10, height: 88 },
    { day: 11, height: 120, highlight: true, value: 250 }
  ]

  return (
    <section className={S.card} aria-label={t('fanGrowth')}>
      <div className={S.content}>
        <header className={S.header}>
          <span className={S.title}>{t('fanGrowth')}</span>
          <div className={S.segments} aria-label={t('fanGrowth')}>
            <span className={S.segment}>{t('weekly')}</span>
            <span className={S.slash}>/</span>
            <span className={S.segment}>{t('monthly')}</span>
            <span className={S.slash}>/</span>
            <span className={S.segment}>{t('annual')}</span>
          </div>
        </header>

        <div className={S.monthLabel} aria-hidden>
          April
        </div>

        <div className={S.chart} aria-hidden>
          {bars.map(b => (
            <div key={b.day} className={S.barCol}>
              {b.highlight && <div className={S.barValue}>{b.value}</div>}
              <div
                className={`${S.bar} ${b.highlight ? S.barHighlight : ''}`}
                style={{ height: `${b.height}px` }}
              />
              <div className={S.dayLabel}>{b.day}</div>
            </div>
          ))}
        </div>
      </div>

      <div className={S.comingSoonOverlay} aria-hidden>
        <p className={S.comingSoonText}>{t('comingSoon')}</p>
      </div>
    </section>
  )
}

export default FanGrowthCard
